import { useContext, useEffect } from 'react';

import Background from '~/components/Player/FullscreenPlayer/Background';
import { PlayerContext } from '~/components/Player/PlayerContextProvider';
import PlayerControls from '~/components/Player/PlayerControls';
import Scrubber from '~/components/Player/Scrubber';
import { useFeatureFlag } from '@audacy-clients/core/atoms/config/settings';
import { nowPlaying } from '@audacy-clients/core/atoms/player';
import TranscriptBottomSheet from '~/components/Transcript/TranscriptBottomSheet';
import BottomOptions from './BottomOptions';
import ContentOverview from './ContentOverview';
import styles from './styles';
import {EpisodeSubType} from '@audacy-clients/client-services';
import { useRecoilValue } from 'recoil';
import useTranscript from "~/components/Transcript/TranscriptContent/useTranscript";
// import useTranscript from

export type IFullPlayerProps = {
  isInfoVisible: boolean;
  isQueueVisible: boolean;
  onQueueClick: () => void;
};

const FullPlayer = ({
  isInfoVisible,
  isQueueVisible,
  onQueueClick,
}: IFullPlayerProps): JSX.Element => {
  const { setIsFullscreenPlayer } = useContext(PlayerContext);
  const nowPlayingItem = useRecoilValue(nowPlaying);
  const isPodcastTranscriptEnabled =  useFeatureFlag('podcastTranscript');

  const isPodcast = nowPlayingItem?.episodeDataObject?.subtype === EpisodeSubType.PODCAST_EPISODE;
  const { isTranscriptAvailable } = useTranscript();

  useEffect(() => {
    setIsFullscreenPlayer(true);
    return () => setIsFullscreenPlayer(false);
  }, [setIsFullscreenPlayer]);

  return (
    <div css={styles.container}>
      <Background />
      <ContentOverview isInfoVisible={isInfoVisible} />
      {isPodcastTranscriptEnabled && isPodcast && isTranscriptAvailable &&
        (<TranscriptBottomSheet isQueueVisible={isQueueVisible} onQueueClick={onQueueClick}/>)
      }

      <div css={styles.controlsContainer}>
        <Scrubber shouldDisplayTime isFullPlayer />
        <PlayerControls />
        <BottomOptions isQueueVisible={isQueueVisible} onQueueClick={onQueueClick} />
      </div>
    </div>
  );
};

export default FullPlayer;
